import { defineMessages } from 'react-intl';

export default defineMessages({
  partingMessage: {
    id: 'unsubscribe.successful.partingMessage',
    description:
      'Parting statement for the communication preferences unsubscribe page',
    defaultMessage: "We're sad to see you go, but you're always welcome back.",
  },
  personalizedEmailsHeading: {
    id: 'unsubscribe.successful.personalizedEmailsHeading',
    description: 'Heading for when personalized emails are unsubscribed from',
    defaultMessage: "You're unsubscribed from emails based on your info",
  },
  promotionalEmailsHeading: {
    id: 'unsubscribe.successful.promotionalEmailsHeading',
    description: 'Heading for when promotional emails are unsubscribed from',
    defaultMessage: "You're unsubscribed from promotional emails",
  },
});
